export const toProjectIds = (projects: (string | number)[] = []): number[] =>
  projects.join(',') as unknown as number[]
